import { useForm } from './form'
import { Label } from './common/label'

export const FormSimpleNumber = ({ name, label, required, hidden, readonly }) => {
  const { register } = useForm(name, { required, valueAsNumber: true, shouldDirty: true })

  return (
    <Label name={name} label={label} required={required} hidden={hidden}>
      <input className={`form-control ${readonly && 'bg-secondary-subtle'}`} type="number" {...register()} readOnly={readonly} />
    </Label>
  )
}
